<template>
    <div>
        <div class="pure-g" v-if="!readonly">
            <div id="moduleBox" class="pure-u-4-24">
                <select id="moduleDropDown" v-model="selectedModule">
                    <option v-for="module in  allModules" :key="module.name" :value="module._links.self.href">{{ module.name }}</option>
                </select>
            </div>
            
            <div id="addModuleBox" class="pure-u-3-24">
                <a v-on:click="addCustomerModule">Hinzuf&uuml;gen</a>
            </div>
        </div>
        <div class="pure-g">
            <div id="roleBox" class="pure-u-15-24">
            <table id="tableCustomerRole" class="pure-table table">
            <thead>
                <tr> 
                    <th>Modul</th>
                    <th>Typ</th>
                    <th class="colAction" v-if="!readonly"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(module, index) in  customerModules" :key="index">
                    <td id="colCustomerModuleName">{{ module.name }}</td>
                    <td id="colCustomerModuleType">{{ module.type }}</td>
                    <td v-if="!readonly">
                    <a v-on:click="removeCompanyModule(module)"><delete-icon fillColor="#ff4d4d"/></a>
                    </td>
                </tr>
            </tbody>
            </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import DeleteIcon from "vue-material-design-icons/delete.vue"
import VueSingleSelect from "vue-single-select"
import { getApiUrl } from '@/utils/api.js'
import { getJwt } from "@/utils/auth.js"

export default {
    name: 'moduleList',
    components: {
        DeleteIcon,
        VueSingleSelect
    },
    props: {
        customerUrl: String,
        modules: Array,
        readonly: Boolean
    },
    data: function() {
        return {
            customerModules: [],
            allModules: [],
            selectedModule: null
        }
    },
    mounted: function() {
        console.log(this.customerUrl)
        this.loadAllModules()
    },
    updated: function() {
        this.loadData(this.customerUrl)
    },
    methods: {

        loadAllModules() {

            axios(
                { 
                    method: 'GET', 
                    'url': getApiUrl() + '/v0/modules',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getJwt()
                    }
                })
                .then(
                    result => {                
                        this.allModules = result.data.data
                    },
                    error => {
                        console.error(error)
                    }
            )
        },

        loadData: function(customerUrl) {

             axios(
                { 
                    method: 'GET', 
                    'url': customerUrl + '/modules',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getJwt()
                    }
                })
                .then(
                    result => {                
                        this.customerModules = result.data.data
                    },
                    error => {
                        console.error(error)
                    }
            )   
        },

        removeCompanyModule: function(module) {

            var moduleUrl = module._links.self.href
            console.log('Remove: ' + moduleUrl)

            axios(
                { 
                    method: 'PUT', 
                    'url': this.customerUrl + '/modules',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getJwt()
                    },
                    data: {
                        action: 'REMOVE',
                        url: moduleUrl
                    }
                })
                .then(
                    result => {                
                        this.loadData(this.customerUrl)
                    },
                    error => {
                        console.error(error)
                    }
            )
        },

        addCustomerModule: function() {

            var moduleUrl = this.selectedModule

            axios(
                { 
                    method: 'PUT', 
                    'url': this.customerUrl + '/modules',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getJwt()
                    },
                    data: {
                        action: 'ADD',
                        url: moduleUrl
                    }
                })
                .then(
                    result => {                
                        this.loadData(this.customerUrl)
                    },
                    error => {
                        console.error(error)
                    }
            )
        }
    }
}
</script>

<style>

#addModuleBox {
    cursor: pointer;
    padding-left: 7px;
    padding-top: 11px;
    
}

#moduleBox {
    padding-right: 7px;
    width: 300px;
}

#moduleDropDown {
    width: 100%;
}
</style>
